export default {
  "content": "<g clip-path=\"url(#a)\"><path d=\"M1.757 2.257a6 6 0 108.486 8.486 6 6 0 00-8.486-8.486M9.182 5.75a.75.75 0 110 1.5H6.75v2.432a.75.75 0 01-1.5 0V7.25H2.818a.75.75 0 010-1.5H5.25V3.318a.75.75 0 111.5 0V5.75z\" fill=\"#6161FF\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 .5h12v12H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "12",
    "height": "13",
    "viewBox": "0 0 12 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};